// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, browser:true, react:true*/
import {useEffect, useContext, useState, useRef} from 'react';
import plus_ui from '/www/hola/pub/plus_ui.js';
// @ts-ignore
import {get_url_plan_or_default} from '/www/hola/pub/join_n.js';
// @ts-ignore
import {App_context} from '/www/hola/pub/context.js';
import hola_opt from 'hola_opt';
import zutil from '/util/util.js';
import etask from 'zetask';
// @ts-ignore
import plus_util from '/www/hola/pub/plus_util.js';
// @ts-ignore
import {get_coupon_flow, use_plans, get_plans_info, get_plan_ids,
// @ts-ignore
    get_plans_info_obj, set_plan_opt, get_discount_plan, set_fixed_plan_ids,
    // @ts-ignore
    get_min_price_plan}
    from '/www/hola/pub/plans_util.js';
import {use_qs_with_set} from '../../lib/use_qs';
import {check_email, get_click_data} from 'hola_pub_util';
import eec from '/www/hola/pub/eec.js';
import {useLocation} from 'react-router-dom';
import zurl from '/util/url.js';
import hola_login from '/www/hola/pub/login.js';
// @ts-ignore
import {get_price_plan} from '../../../../../svc/account/pub/membership.js';
import {format_price} from 'zcountry';
import gtm from '../../gtm';
import {use_screen} from '../../lib/screen_util';

const plan_to_url = plan=>plan && (plan.type=='ultra' ? plan.id :
    plan.period.toLowerCase().replace(' ', ''));
const perr = opt=>{
    return plus_util.perr({...opt, id: opt.id.replace(/^www_join1/,
        `www_join2`)});
};
export const check_from_bext = (_search: string, _ref?: string)=>{
    if (!_search)
        return false;
    if (_search.indexOf('qid=')>-1)
        return true;
    const qs = zurl.qs_parse_url(_search, {safe: true});
    const ref = _ref || qs.ref || '';
    if (ref.endsWith('_email') || ref.includes('holiday_season'))
        return true;
    const search = zurl.qs_str(qs);
    return search.indexOf('bext')>-1 ||
        search.indexOf('holaext')>-1 ||
        search.indexOf('test_placebo')>-1 ||
        search.indexOf('ext_upgrade')>-1 ||
        search.indexOf('form=true')>-1;
};
const script_err = {};
const on_script_load_err = ev=>{
    const src = zutil.get(ev, 'target.src')||'';
    const match = src.match(/(2pay\.js|bluesnap\.js|js\.stripe\.com|paypal\.com\/sdk\/js|pay\.google\.com)/);
    perr({id: 'www_premium_payment_script_load_err', info: {src}});
    if (match)
        Object.assign(script_err, {[match[1]]: true});
};
let f_bext = check_from_bext(location.search);
let debug_ui = location.search && location.search.indexOf('debug_ui')>-1;
if (f_bext || debug_ui)
    plus_ui.init(plus_util.api, on_script_load_err);

const get_default_provider = (api, plan)=>{
    if (!plan || !api)
        return '';
    // XXX dmitriiz: this function is for SSR. We need some default provider
    // for defining currency. In client side during the form rendering we
    // will/can change it
    if (plan.avangate_id && (api.avangate && api.avangate_2pay
        && !api.is_avangate_fallback
            || !plan.stripe && !plan.bluesnap))
    {
        return 'avangate';
    }
    if (plan.avangate_product && (api.avangate
        && !api.is_avangate_fallback
            || !plan.stripe && !plan.bluesnap))
    {
        return 'avangate';
    }
    if (plan.stripe && (api.stripe || !plan.bluesnap))
        return 'stripe';
    if (!plan.bluesnap)
        return 'avangate'; // as default
    if (api.bluesnap_hpf || !plan.stripe)
        return 'bluesnap';
    return 'avangate'; // as default
};

export const use_premium_page = ({from_bext, from_nav_bar}:
        {from_bext:boolean, from_nav_bar?:boolean})=>{
    const [is_payment_form_open, set_is_payment_form_open_o] = useState(false);
    const set_is_payment_form_open = val=>{
        if (val)
            perr({id: 'www_premium_click_open_form'});
        else
            perr({id: 'www_premium_click_close_form'});
        return set_is_payment_form_open_o(val);
    };
    // @ts-ignore
    const {user, is_plus} = useContext(App_context);
    const {pathname, search} = useLocation();
    const [coupon, set_coupon] = useState('');
    const [applied_coupon, apply_coupon] = useState('');
    const [already_plus, set_already_plus] = useState(false);
    const [currency_state, set_currency] = useState(hola_opt.user_currency);
    const [api, set_api] = useState(plus_util.api);
    const [api_loaded, set_api_loaded] = useState(false);
    const [slide, set_slide] = useState('payment');
    const [plan_v, set_plan_v] = useState(0);
    const bump_plan = ()=>set_plan_v(plan_v+1);
    const {qs: {ref, plan, plan_id}, set_qs} = use_qs_with_set();
    const {width} = use_screen();
    const is_mobile = width < 768;
    const from_bext_qs = check_from_bext(search, ref);
    const [selected_plan, set_selected_plan] =
        useState(get_url_plan_or_default({plan: '3y'}));
    useEffect(()=>{
        let _plan = get_url_plan_or_default({plan: '3y'});
        set_selected_plan(_plan);
        set_slide(coupon_flow && !coupon ? 'coupon' : 'payment');
    }, [plan, plan_id, plan_v]);
    useEffect(()=>{
        if (!from_bext && !debug_ui&& !from_nav_bar)
        {
            setTimeout(()=>plus_ui.init(plus_util.api, on_script_load_err),
                2000);
        }
    }, []);
    const coupon_flow = get_coupon_flow();
    const load_user = force=>etask(function*(){
        let _user = yield plus_util.login_get_user(force);
        if (_user && _user.coupon && _user.coupon.type && (!coupon_flow
            || coupon_flow==_user.coupon.type))
        {
            set_coupon(_user.coupon._id);
            if (_user.coupon.currency)
                set_currency(_user.coupon.currency);
            if (coupon_flow=='promo_plan')
            {
                set_fixed_plan_ids(['promo_y1', 'promo_y3']);
                if (ref && !ref.includes(_user.coupon.affiliate))
                    set_qs({ref: _user.coupon.affiliate+ref});
            }
        }
        set_slide(coupon_flow && !coupon ? 'coupon' : 'payment');
        set_api_loaded(true);
        return _user;
    });
    const [plans, set_plans] = useState(zutil.values(
        get_plans_info(get_plan_ids())));
    const plans_version = use_plans();
    useEffect(()=>{
        const plans_local = zutil.values(get_plans_info(get_plan_ids()));
        set_plans(plans_local);
    }, [pathname, plans_version]);
    const [state, set_state] = useState({email:
        zutil.get(user, 'emails[0].value'), email_error: null});
    const set_email = email=>set_state(_st=>{
        email = `${email || ''}`.trim();
        return {..._st, email, email_error: null};
    });
    const set_email_err = email_error=>set_state(_st=>{
        return {..._st, email_error};
    });
    let {email, email_error} = state;
    const check_email_fn = _email=>etask(function*(){
        if ((_email || email) && !user)
        {
            if (!hola_opt.www_hola.full_email_validation)
                return true;
            const res_email_check = yield check_email(_email||email);
            if (res_email_check.err || res_email_check.used)
            {
                const err_code = res_email_check.err ||
                    res_email_check.used && 'email_used';
                set_email_err(hola_login.email_errors(_email || email,
                    err_code, 'err_msg', ()=>{
                        const url = encodeURIComponent(zurl.get_path(
                            window.location.href));
                        const enc_url = `?next=${url}`;
                        perr({id: 'www_premium_checkout_login'});
                        hola_login.open_modal({enc_url, email: _email||email});
                    }));
                return false;
            }
        }
        return true;
    });
    const set_plan = (_plan, _opt = {})=>{
        _plan = get_discount_plan(_plan) || _plan;
        set_plan_opt(_opt);
        perr({id: `www_premium_plan_click_${_plan.id}`});
        plus_ui.start_checkout();
        gtm.push({event: 'choose_plan', id: _plan.id});
        set_qs({
            plan: from_bext_qs ? undefined : plan_to_url(_plan),
            plan_id: from_bext_qs ? _plan && _plan.id : undefined,
        });
        if (selected_plan.id && _plan.id && selected_plan.id!=_plan.id)
            bump_plan();
    };
    const selected_plan_info = get_plans_info_obj(selected_plan);
    const [provider, set_provider] = useState(get_default_provider(api,
        selected_plan_info));
    const {currency, currencies} = provider ?
      plus_util.get_currency_o(currency_state, selected_plan_info, provider)
      : {currency: currency_state, currencies: []};
    let opt = {
        plan: selected_plan_info,
        plans,
        set_plans,
        coupon,
        set_coupon,
        applied_coupon,
        apply_coupon,
        user,
        currency,
        currencies,
        slide,
        set_currency: value=>set_currency(value ? value.toUpperCase() : 'USD'),
        user_email: zutil.get(user, 'emails[0].value'),
        country: (hola_opt.user_country||'').toLowerCase(),
        load_user,
        email_error,
        set_email_err,
        set_email,
        email,
        check_email: check_email_fn,
        api,
        api_loaded,
        script_err,
        provider,
        set_provider,
        on_script_load_err,
        set_plan,
        go_back: ()=>{
            // do nothing
        },
        set_api: change=>{
            plus_util.api = {...plus_util.api, ...change};
            set_api(plus_util.api);
        },
        on_continue: ()=>{
            perr({id: 'www_premium_continue_click'});
            // do nothing
        },
        show_back: false,
        disable_scroll_to_top: true,
    };
    const min_price_plan = get_min_price_plan(plans||[])||{};
    const min_price = get_price_plan(min_price_plan, currency)?.month_price;
    const min_price_formatted = min_price ?
      format_price(currency, min_price) : '';
    useEffect(()=>{
        document.addEventListener('click', event=>{
            const {id: click_id, info} = get_click_data(event.target);
            if (click_id)
                perr({id: `www_premium_click_${click_id}`, info});
        });
        plus_util.set_ppc_cookie();
        let plans_info = get_plans_info(get_plan_ids());
        let plans_ = Object.keys(plans_info).map(key=>{
            let {id, name, price} = plans_info[key];
            return {id, name, price, category: 'vpn-b2c',
                list: 'Plus page plans'};
        });
        eec.view_item_list(plans_);
        if (!from_nav_bar)
        {
            etask(function*(){
                const _user = yield load_user(false);
                const page = pathname.slice(1).replace('/', '_');
                const info = {login: _user && _user.hola_uid, template:
                    `join2`};
                perr({id: 'www_premium_visit', info});
                perr({id: `www_premium_${page}_visit`, info});
            });
        }
    }, []);
    const [has_form, set_has_form] = useState(from_bext_qs);
    const form_ref = useRef<HTMLDivElement>();
    useEffect(()=>{
        if (from_bext)
            return;
        if (has_form)
            perr({id: 'www_premium_with_form_by_default'});
        return ()=>{
            perr({id: 'www_premium_top_form_removed'});
        };
    }, [has_form]);
    const open_form = ()=>{
        if (is_plus)
            set_already_plus(true);
        set_is_payment_form_open(true);
    };
    const close_already_plus = ()=>{ set_already_plus(false); };
    const close_form = ()=>{ set_is_payment_form_open(false); };
    return {
        from_bext_qs, form_ref, is_payment_form_open, opt, has_form,
        ref, plan_id, min_price_formatted, open_form, close_form,
        currencies, currency, plan, set_plan, plans, set_has_form,
        already_plus, close_already_plus, is_mobile,
    };
};

export type t_premium_page_opt = ReturnType<typeof use_premium_page>['opt'];
type t_slide_id = 'hero'|'promo1'|'promo2'|'features'|'reviews'|'compare'|'qa'|
    'plans';
interface i_slide_opt {
    id: t_slide_id;
    height?: number;
    fixed?: string;
}
interface i_lp_conf {
    animation?: {
        dur?: number;
        fn?: string;
        bottom?: string;
    };
    slides?: i_slide_opt[];
}
interface i_slide extends i_slide_opt {
    index: number;
    top: number;
    bottom: number;
    ref: HTMLDivElement;
    prev?: i_slide;
    next?: i_slide;
}
type i_slides = Record<t_slide_id, i_slide>;
const default_conf = {
    slides: [
        {id: 'hero', height: 2000},
        {id: 'promo1', height: 2000},
        {id: 'features', fixed: 300},
        {id: 'reviews', fixed: 300},
        {id: 'compare', fixed: 800},
        {id: 'qa', fixed: 300},
        {id: 'plans', fixed: 300},
        {id: 'promo2', height: 2000},
    ],
};
export const use_premium_landing = (root: HTMLDivElement,
    portal_el: HTMLDivElement, gradient_el: HTMLDivElement)=>
   {
    const conf = (hola_opt.www_hola.premium_land || default_conf) as i_lp_conf;
    const active_obj = useRef('hero');
    const prev_slide = useRef('');
    const slides_obj = useRef<i_slides>({} as i_slides);
    const slides = slides_obj.current;
    const {screen} = use_screen();
    useEffect(()=>{
        if (!root || !conf || !screen)
            return;
        const is_mobile = ['xs', 'sm'].includes(screen);
        let all_height = 0;
        conf.slides?.forEach((_slide, i)=>{
            const {id, height, fixed} = _slide;
            const ref = root.children[id];
            if (fixed)
                ref.style.setProperty('--fixed', `${fixed}px`);
            if (height && !is_mobile)
                ref.style.height = `${height}px`;
            const h = is_mobile || !height ? ref.clientHeight : height;
            const top = all_height;
            all_height += h;
            const bottom = all_height;
            slides[id] = {id, height: h, ref, top, bottom, fixed,
                index: i};
        });
        conf.slides?.forEach(({id}, i)=>{
            let prev, next;
            const cur = slides[id];
            if (prev = conf.slides[i-1]?.id)
                cur.prev = slides[prev];
            if (next = conf.slides[i+1]?.id)
                cur.next = slides[next];
        });
        Object.keys(conf?.animation||{}).forEach(k=>{
            root.style.setProperty(`--${k}`, `${conf.animation[k]}`);
        });
        const get_active = scrolled=>{
            const v = active_obj.current;
            const cur = slides[v];
            const pos = (scrolled - cur.top) / cur.height;
            const gradient_pos = v==slides.promo1.prev.id ||
                v==slides.promo2.prev.id ? pos :
                v=='promo1' || v=='promo2' ? 1 - pos : 0;
            gradient_el.style.setProperty('--gradient_pos',
                `${gradient_pos}`);
            if (scrolled > cur.bottom && cur.next)
            {
                prev_slide.current = v;
                return cur.next.id;
            }
            if (scrolled <= cur.top && cur.prev)
            {
                prev_slide.current = v;
                return cur.prev.id;
            }
            return v;
        };
        const handle_scroll = ()=>{
            const b = root.getBoundingClientRect();
            const scrolled = -b.y;
            conf.slides?.forEach(({id})=>{
                const cur = slides[id];
                const {ref, top, height} = cur;
                const top_shift = scrolled - top;
                let pos = top_shift / height;
                const slide_op = pos > 0 ? 1 : Math.max(0, 1 + pos);
                ref?.style.setProperty('--slide_op', `${slide_op}`);
                if (id=='hero')
                {
                    const max_scale = is_mobile ? 10 :
                        document.body.clientWidth / 196;
                    const portal_op = 1 - Math.min(1, pos);
                    const portal_scale = Math.max(1, pos * max_scale);
                    portal_el.style.setProperty('--portal_op', `${portal_op}`);
                    portal_el.style.setProperty('--portal_scale',
                        `${portal_scale}`);
                }
                if (id=='compare')
                {
                    const cta_top = Math.min(0, Math.max(-570,
                        ref.clientHeight * pos - 32));
                    ref.style.setProperty('--cta_top', `${cta_top}px`);
                }
            });
            active_obj.current = get_active(scrolled);
        };
        const on_scroll = ()=>{ window.requestAnimationFrame(handle_scroll); };
        window.addEventListener('scroll', on_scroll);
        window.addEventListener('touchmove', on_scroll);
        return ()=>{
            window.removeEventListener('scroll', on_scroll);
            window.removeEventListener('touchmove', on_scroll);
        };
    }, [root, conf, screen, portal_el, gradient_el]);
};
